import { ButtonPrimary } from '../../../../utils/Button';

// function TextPreview(text = '') {
//     const [title, description] = text.split('\n');
//     return (
//         <>
//             <p>{title}</p>
//             <p className="text-sm">{description}</p>
//         </>
//     );
// }

function InfoCard({ title, value }) {
    return (
        <div className="flex justify-between items-center w-full p-2 md:p-3 rounded-10 bg-primary-50 overflow-hidden box-border">
            <div className="w-10/12">
                <h3 className="text-primary-700 text-sm md:text-base font-normal">
                    {title || '--'}
                </h3>
                <div className="w-full text-primary text-base font-medium bg-transparent">
                    {value}
                </div>
            </div>
        </div>
    );
}

function BasicInformation({ data, setOpenModal }) {
    const validity = data?.validity ? `${data?.validity} days` : '';

    return (
        <div className="mb-4">
            <div className="flex justify-end mb-3">
                <ButtonPrimary
                    title="Update Information"
                    onClick={() => setOpenModal('update_info')}
                />
            </div>
            <div className="flex flex-col gap-3">
                <InfoCard title="Organization Name" value={data?.organization || '------'} />
                <div className="flex gap-3">
                    <InfoCard title="Email" value={data?.email || '------'} />
                    <InfoCard title="Phone Number" value={data?.phoneNumber || '------'} />
                </div>
                <InfoCard title="Address" value={data?.address || '------'} />

                {/* <div className="flex gap-3">
                    <InfoCard
                        title="Signatory 1"
                        value={TextPreview(data?.signatory1) || '------'}
                    />
                    <InfoCard
                        title="Signatory 2"
                        value={TextPreview(data?.signatory2) || '------'}
                    />
                </div> */}
                <InfoCard title="Validity" value={validity} />
            </div>
        </div>
    );
}

export default BasicInformation;
